export const REVIEW_PLACEHOLDER_TXT = `\
Напишите, что тестировщик должен спросить в переписке или при звонке? Какие качества надо отразить в отзыве?\
`;

export const REVIEW_ERROR_MESSAGE = `\
Максимально 550 символов. Мы ограничили количество символов, чтобы исполнители быстрее обрабатывали задание.\
`;

export const COMMENT_PLACEHOLDER_TXT = `\
Напишите, что исполнитель должен написать в комментарии?\n\
\n\
Можете привести примеры комментариев.\n\
`;

export const HINT_REVIEW_NOTIFICATION = <p>1 отзыв = 1 уникальный текст = 1 проект
<br />
<br />
Чтобы заказать больше отзывов:
<br />
<br />
А. Составьте универсальное задание, что надо исполнителям отразить в отзыве.
<br />
<br />
Б. Или создайте новый проект с другим текстом отзыва.</p>
